// Configuração de versão - AUTO-GERADO
// Este arquivo é atualizado automaticamente pelo script sync-versions.js
// NÃO edite manualmente - as versões vêm do .release-please-manifest.json
//
// Durante build Docker, este arquivo pode usar variáveis de ambiente:
// VITE_APP_VERSION para UI_VERSION
// API_VERSION vem do DEFAULT_API_VERSION

// Valores padrão que serão usados se variáveis de ambiente não estiverem disponíveis
// Estes valores são sincronizados do .release-please-manifest.json
const DEFAULT_UI_VERSION = '0.1.14';
const DEFAULT_API_VERSION = '0.1.10';

// Versões da aplicação
// Prioridade: variável de ambiente (build time) > valor padrão
// Validação: apenas usa VITE_APP_VERSION se for uma string não vazia
const getEnvVersion = (): string | undefined => {
    if (typeof import.meta === 'undefined') return undefined;
    const envVersion = import.meta.env?.VITE_APP_VERSION;
    // Apenas usar se for string válida e não vazia
    if (typeof envVersion === 'string' && envVersion.trim().length > 0) {
        return envVersion.trim();
    }
    return undefined;
};

export const UI_VERSION: string = getEnvVersion() || DEFAULT_UI_VERSION;

export const API_VERSION: string = DEFAULT_API_VERSION;

// Metadados de versão (opcional, para debug)
export const VERSION_INFO = {
    ui: UI_VERSION,
    api: API_VERSION,
    updated: new Date().toISOString()
};
